import printJS from "print-js"
import { api_URL } from "./Constantes";

export const printpdf = (url) => {
    printJS({
      printable: `${api_URL}${url}`,
      type: 'pdf'
    });
  };
  